module.exports = __webpack_public_path__ + "img/title.7d2af617.png";


//////////////////
// WEBPACK FOOTER
// ./_source/cqsx/pages/cqsx/cmps/home/img/title.png
// module id = 226
// module chunks = 0